import Backgrounds from './backgrounds';
export default Backgrounds;